export const sanitizeEmailSignature = (html: string): string => {
  if (!html) return "";

  // Create a temporary div to work with the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Step 1: Remove trailing line breaks and empty elements
  const removeTrailingBreaks = (element: Element): void => {
    const children = Array.from(element.children);

    // Remove trailing <br> tags and empty elements from the end
    for (let i = children.length - 1; i >= 0; i--) {
      const child = children[i];
      const textContent = child.textContent?.trim();
      const hasVisibleContent = child.querySelector(
        "img, br, hr, strong, em, u, a"
      );

      if (child.tagName === "BR" || (!textContent && !hasVisibleContent)) {
        child.remove();
      } else {
        // If this element has content, recursively clean it and stop
        removeTrailingBreaks(child);
        break;
      }
    }
  };

  removeTrailingBreaks(tempDiv);

  // Step 2: Clean up the HTML structure
  let result = tempDiv.innerHTML
    // Remove empty paragraphs
    .replace(/<p[^>]*>\s*<\/p>/gi, "")
    // Remove paragraphs that only contain <br>
    .replace(/<p[^>]*>\s*<br\s*\/?>\s*<\/p>/gi, "<br>")
    // Normalize multiple line breaks (more than 2 consecutive)
    .replace(/(<br\s*\/?>\s*){3,}/gi, "<br><br>")
    // Remove leading/trailing whitespace
    .trim();

  // Step 3: Remove any remaining trailing <br> tags
  result = result.replace(/(<br\s*\/?>\s*)+$/gi, "");
  result = result.replace(/^(<br\s*\/?>\s*)+/gi, "");

  // Step 4: Ensure the signature has a proper container
  if (!result.startsWith("<div") && !result.startsWith("<p")) {
    result = `<div>${result}</div>`;
  }

  return result;
};
